export default __webpack_public_path__ + "static/media/Avatar-19.530d927b.png";